import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

export interface BreakpointValuesToCssProperties {
    values: (number | string | null)[];
    properties: string[];
    unit?: string | null;
}

export const breakpointValuesToCssProperties = (theme: BaseTheme, items: BreakpointValuesToCssProperties[]) => {
    return theme.breakpoints.keys.map((breakpoint, index) => {
        let result = "";

        items.forEach(item => {
            const { properties, unit } = item;
            const value = item.values[index] ?? null;

            if (value !== null) {
                result = properties.reduce((rest, property) => `${rest}${property}:${value}${unit ?? ""};`, result);
            }
        });

        return result ? css({}, result) : null;
    });
};

const breakpointValuesMediaQueries = (
    theme: BaseTheme,
    items: BreakpointValuesToCssProperties[],
    mediaOption?: keyof typeof mediaOptions,
) => {
    return breakpointMediaQueries(theme, breakpointValuesToCssProperties(theme, items), mediaOption);
};

export default breakpointValuesMediaQueries;
